import { Button } from 'primereact/button';

import {
  useEmbryoCollectionReport,
  useExportSealLabFormReport,
  useFreshShipmentFormReport,
} from '@/services/reports';

import { FreshShipmentReportType } from '../utils/types';

export const FreshShipmentsPdfButton = ({
  shipmentNumber,
  freshShipmentId,
}: {
  shipmentNumber: string;
  freshShipmentId: string;
}) => {
  const [createFreshShipmentImplantFormReport] = useEmbryoCollectionReport();

  const [createFreshShipmentFormReport] = useFreshShipmentFormReport();

  const [createFreshShipmentExportSealLabFormReport] =
    useExportSealLabFormReport();

  async function createFreshShipmentReport({
    reportType,
    shipmentNumber,
    freshShipmentId,
    accountNumber,
  }: {
    reportType: FreshShipmentReportType;
    shipmentNumber: string;
    freshShipmentId?: string;
    accountNumber?: string;
  }) {
    try {
      let result;

      if (reportType === 'IMPLANT') {
        result = await createFreshShipmentImplantFormReport({
          accountCode: accountNumber as string,
          shipmentCode: shipmentNumber as string,
        });
      } else if (reportType === 'EXPORT_SEAL') {
        const reportParams = {
          accountCode: accountNumber as string,
          shipmentCode: shipmentNumber as string,
          freshShipmentId: freshShipmentId as string,
        };
        result = await createFreshShipmentExportSealLabFormReport(reportParams);
      } else {
        result = await createFreshShipmentFormReport({
          accountCode: accountNumber as string,
          shipmentCode: shipmentNumber as string,
        });
      }

      if (!result) {
        console.error('No report received from the server');
        return;
      }
    } catch (error) {
      console.error('Error creating fresh shipment report:', error);
    }
  }

  return (
    <div className={`fresh-shipments-pdf-button__wrapper`}>
      <Button
        severity="secondary"
        icon="pi pi-file-pdf"
        text
        className={`fresh-shipments-pdf-button`}
        onClick={() =>
          createFreshShipmentReport({
            reportType: 'REGULAR',
            shipmentNumber,
            accountNumber: '',
          })
        }
      ></Button>
      <Button
        severity="secondary"
        icon="pi pi-file-pdf"
        text
        className={`fresh-shipments-pdf-button`}
        onClick={() =>
          createFreshShipmentReport({
            reportType: 'IMPLANT',
            shipmentNumber,
            accountNumber: '',
          })
        }
      ></Button>
      <Button
        severity="secondary"
        icon="pi pi-file-pdf"
        text
        tooltip="Export Seal Form"
        className={`fresh-shipments-pdf-button`}
        onClick={() =>
          createFreshShipmentReport({
            reportType: 'EXPORT_SEAL',
            shipmentNumber,
            freshShipmentId,
          })
        }
      ></Button>
    </div>
  );
};
